"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelLabels = void 0;
const types_1 = require("./types");
exports.TunnelLabels = {
    [types_1.TunnelType.internal]: 'Internal',
    [types_1.TunnelType.external]: 'Public',
    [types_1.TunnelType.interRegion]: 'Inter Regional',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJuYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYXBpL3YxL2ludGVybmFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLG1DQUFvQztBQWdCdkIsUUFBQSxZQUFZLEdBQUc7SUFDeEIsQ0FBQyxrQkFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFLFVBQVU7SUFDakMsQ0FBQyxrQkFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFLFFBQVE7SUFDL0IsQ0FBQyxrQkFBVSxDQUFDLFdBQVcsQ0FBQyxFQUFFLGdCQUFnQjtDQUM3QyxDQUFBIn0=